/**
 * weather-edit.js
 */

import React from 'react';
import {
  FormControl,
  FormHelperText,
} from '@mui/material';
import { useFormContext, useWatch, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { EditorIconSection } from 'components/icon-section/icon-section';
import FeatureBox from 'components/feature-box';
import HelpTextItem from 'components/menu-drawer/help-text-item';
import FormSectionTitle from 'components/menu-drawer/form-section-title';
import EditorAccordion from 'components/menu-drawer/editor-accordion';
import { isWeatherEmpty, formatWeatherSummary } from 'utils/weather';
import WeatherEditForm from './weather-edit-form';



export default function WeatherEdit(props) {
  const {
    name,
    location,
    datetime,
    drawerState,
    translation,
  } = props;
  const { t } = useTranslation(translation);
  const { control, setValue, formState } = useFormContext();
  const [loading, setLoading] = React.useState(false);
  const weatherValue = useWatch({ control, name });


  const validate = (v) => {
    return (
      v 
      && (
        (v.conditions && v.conditions.name.length > 1000)
        || (v.temperature && v.temperature.name.length > 1000)
        || (v.windDirection && v.windDirection.name.length > 1000)
        || (v.windSpeed && v.windSpeed.name.length > 1000)
      )
    )
      ? t('weather.general.errMsgLength')
      : true;
  }
  

  const doAutoFill = Boolean(
    isWeatherEmpty(weatherValue) 
    && location.city 
    && location.region
    && location.country
    && datetime
  );


  return (
    <>
      <EditorIconSection
        iconName='weather'
        iconMarginTop={20}
        helpProps={{
          translation,
          section: 'weather'
        }}
      >
        <FeatureBox loading={loading}>
          <HelpTextItem
            sidebarText={drawerState.sidebarText}
            title={t('weather.general.helpTitle')}
            text={t('weather.general.helpInfo')}
          >
            {focusHandlers =>
              <EditorAccordion
                highlight
                name={t('weather.sectionName')}

                summary={<>
                  <FormControl error={Boolean(formState.errors?.weather)}>
                    <FormSectionTitle>
                      {t('weather.sectionName')}:
                      {formatWeatherSummary(weatherValue)}
                    </FormSectionTitle>

                    {Boolean(formState.errors?.weather) &&
                    <FormHelperText>
                      {formState.errors?.weather?.message}
                    </FormHelperText>}
                  </FormControl>
                </>}

                detail={<>
                  <div style={{ padding: '4px 0' }}>
                    <Controller
                      control={control}
                      name={name}
                      rules={{ validate }}
                      render={({ field }) =>
                        <WeatherEditForm
                          value={field.value}
                          onChange={val => field.onChange(val)}
                          onInit={(val, shouldDirty) => setValue(name, val, { shouldDirty: shouldDirty })}
                          doAutoFill={doAutoFill}
                          setLoading={setLoading}
                          onFocus={focusHandlers.onFocus}
                          onBlur={focusHandlers.onBlur}
                          location={location}
                          datetime={datetime}
                        />}
                    />
                  </div>
                </>}
              />}
          </HelpTextItem>
        </FeatureBox>
      </EditorIconSection>
    </>
  );
}